import { render, staticRenderFns } from "./ModalOrderContent.vue?vue&type=template&id=22ade270&scoped=true"
import script from "./ModalOrderContent.vue?vue&type=script&lang=js"
export * from "./ModalOrderContent.vue?vue&type=script&lang=js"
import style0 from "./ModalOrderContent.vue?vue&type=style&index=0&id=22ade270&prod&lang=stylus&scoped=true"
import style1 from "./ModalOrderContent.vue?vue&type=style&index=1&id=22ade270&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ade270",
  null
  
)

export default component.exports